import Icon2N from './Icon2N';

export default Icon2N;
